export default __webpack_public_path__ + "static/media/in.ae748f66.png";